import { createSlice } from "@reduxjs/toolkit";

const schemaSlice = createSlice({
  name: "schema",
  initialState: {
    schema: null,
    loading: false,
    error: null,
  },
  reducers: {
    fetchSchemaRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSchemaSuccess: (state, action) => {
      state.loading = false;
      state.schema = action.payload;
      state.error = null;
    },
    fetchSchemaFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearSchema: (state) => {
      state.schema = null;
      state.error = null;
    },
  },
});

export const {
  fetchSchemaRequest,
  fetchSchemaSuccess,
  fetchSchemaFailure,
  clearSchema,
} = schemaSlice.actions;

export default schemaSlice.reducer;

